import { Command } from '@/app/tracking/api';

export interface UpdateSessionTimeCommandPayload {
  sessionTimeSeconds: number;
}

export const UpdateSessionTimeCommandName = 'update-session-time' as const;

export type UpdateSessionTimeCommand =
      Command<typeof UpdateSessionTimeCommandName, UpdateSessionTimeCommandPayload>;
